import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "container p-0",
  "data-cy": "glossary-modal"
}
const _hoisted_2 = { class: "glossary overflow-auto" }
const _hoisted_3 = { class: "manipulation-area pb-3 pr-3" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Plus" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "glossary-table pr-3 pt-0"
}
const _hoisted_7 = { class: "glossary-table-header glossary-items" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "options-column" }, null, -1)
const _hoisted_9 = { class: "glossary-table-col custom-width-col pl-1 mr-1" }
const _hoisted_10 = { class: "glossary-table-col value-col" }
const _hoisted_11 = { class: "glossary-table-col value-col" }
const _hoisted_12 = { class: "glossary-table-col active-col pl-0 mr-0" }
const _hoisted_13 = { class: "glossary-table-row" }
const _hoisted_14 = { class: "glossary-table-row-container" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Ellipsis" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdp-Edit" })
], -1)
const _hoisted_18 = { class: "menu-text" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdp-Delete" })
], -1)
const _hoisted_20 = { class: "menu-text" }
const _hoisted_21 = ["data-cy", "onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick", "data-cy"]
const _hoisted_25 = {
  key: 1,
  class: "pl-3"
}
const _hoisted_26 = { class: "ml-3" }
const _hoisted_27 = { class: "glossary overflow-auto" }
const _hoisted_28 = { class: "manipulation-area pb-3" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Plus" }, null, -1)
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Upload" }, null, -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Download" }, null, -1)
const _hoisted_35 = {
  key: 0,
  class: "glossary-table glossary-entries-table pt-0"
}
const _hoisted_36 = { class: "glossary-entry-table-header" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "glossary-table-col options-column-entries" }, null, -1)
const _hoisted_38 = { class: "glossary-table-col header-entry-col pl-0" }
const _hoisted_39 = { class: "glossary-table-col header-entry-col pl-0" }
const _hoisted_40 = { class: "glossary-entries-table-row" }
const _hoisted_41 = { class: "glossary-table-row-container" }
const _hoisted_42 = ["data-cy"]
const _hoisted_43 = ["data-cy"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Ellipsis" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdp-Delete" })
], -1)
const _hoisted_46 = { class: "menu-text" }
const _hoisted_47 = {
  key: 1,
  class: "pl-3"
}
const _hoisted_48 = {
  key: 2,
  class: "pl-3"
}
const _hoisted_49 = {
  key: 3,
  class: "pl-3"
}

import { RootState } from "@medapro-types/common/rootstate";
import { reactive, watch, onMounted, onBeforeUnmount, computed, ref, nextTick } from "vue";
import { useState } from "vuex-composition-helpers";
import { GlossaryTypes } from "@medapro-types/AttributeManager/GlossaryTypes";
import spinner from "@common/components/Spinner.vue";
import AddUpdateGlossaryModal from "./AddUpdateGlossaryModal.vue";
import GridSplitter from "@common/components/GridSplitter.vue";
import _ from "lodash";
import glossaryApi from "@services/glossary";
import { useI18n } from "vue-i18n";
import emitter from "tiny-emitter/instance";
import WarningModal from "../WarningModal.vue";

type ViewModel = {
  disableHandleGlossarySelection: boolean;
  openModalFromContextMenu: boolean;
  file: Array<string>;
  selectedGlossaryItemKey: number | undefined;
  glossaryItemKeyForGlossaryToDeactivate: number | undefined;
  isDelete: boolean;
  mainSpinner: boolean;
  spinnerRightActive: boolean;
  selectedOriginalGlossaryEntriesFormat: GlossaryTypes.GlossaryEntry[];
  selectGlossary: boolean;
  hasUnsavedData: boolean;
  doneFetching: boolean;
  isUpdateGlossary: boolean;
  isAddGlossary: boolean;
  selectedGlossary: GlossaryTypes.GlossaryItem | null;
  selectedGlossaryRowId: string;
  glossaryName: string;
  selectedSourceLanguage: GlossaryTypes.glossaryLanguage | null;
  selectedTargetLanguage: GlossaryTypes.glossaryLanguage | null;
  availableSourceLanguages: GlossaryTypes.glossaryLanguage[];
  availableTargetLanguages: GlossaryTypes.glossaryLanguage[];
  inputGlossaryName: string;
  inputSourceLanguage: string;
  inputTargetLanguage: string;
  showAddUpdateGlossary: boolean;
  startGlossaryEntriesToCompareChanges: GlossaryTypes.GlossaryEntry[];
  glossaryEntries: GlossaryTypes.GlossaryEntry[];
  glossaryItems: GlossaryTypes.GlossaryItem[];
  glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[];
  initialized: boolean;
  isDeeplAuthorized: boolean;
  isDeeplAvailable: boolean;
  isImportFileValid: boolean;
  messages: {
    title: string;
    message: string;
  };
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GlossaryModal',
  props: {
    modalName: {}
  },
  setup(__props: any) {

const props = __props;

const { user } = useState<RootState>(["user"]);



const modal = ref();
const { t: $t } = useI18n();

const glossaryEntriesRef = ref<HTMLDivElement[]>([]);

//#region ViewModel
const vm = reactive<ViewModel>({
  disableHandleGlossarySelection: false,
  openModalFromContextMenu: false,
  file: [],
  selectedGlossaryItemKey: undefined,
  glossaryItemKeyForGlossaryToDeactivate: 0,
  isDelete: false,
  mainSpinner: false,
  spinnerRightActive: false,
  selectedOriginalGlossaryEntriesFormat: [],
  selectGlossary: false,
  hasUnsavedData: false,
  doneFetching: false,
  isUpdateGlossary: false,
  isAddGlossary: false,
  selectedGlossary: null,
  selectedGlossaryRowId: "",
  glossaryName: "",
  availableSourceLanguages: [],
  availableTargetLanguages: [],
  selectedSourceLanguage: null,
  selectedTargetLanguage: null,
  inputGlossaryName: "",
  inputSourceLanguage: "",
  inputTargetLanguage: "",
  showAddUpdateGlossary: false,
  startGlossaryEntriesToCompareChanges: [],
  glossaryEntries: [],
  glossaryItems: [],
  glossaryLanguagePairs: [],
  initialized: false,
  isDeeplAuthorized: false,
  isDeeplAvailable: false,
  isImportFileValid: false,
  messages: {
    title: $t("translation.deepLTranslation"),
    message: $t("Activity.Description.DeepLAuthorizationFailed")
  }
});

//#endregion

//#region Validation

async function handleCloseModal(bvModalEvent: Event) {
  if (!vm.isImportFileValid && vm.isDeeplAuthorized && vm.isDeeplAvailable) {
    bvModalEvent.preventDefault();
    vm.isImportFileValid = true;
  }
  if (vm.hasUnsavedData) {
    if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
      bvModalEvent.preventDefault();
    }
  }
  vm.selectedGlossaryRowId = "";
  vm.selectedGlossaryItemKey = undefined;
}

function validateEntries(glossaryEntries: GlossaryTypes.GlossaryEntry[]) {
  let countEqualEntries = 0;
  let filteredGlossaryEntries: GlossaryTypes.GlossaryEntry[] = [];
  for (const entry of glossaryEntries) {
    entry.isValid = true;
    entry.errorMessage = "";
    if (glossaryEntries.length !== 1) {
      filteredGlossaryEntries = glossaryEntries.filter((x) => x !== entry);
      for (const entry2 of filteredGlossaryEntries) {
        if (entry.sourceLanguage.trim() == entry2.sourceLanguage.trim()) {
          countEqualEntries++;
          entry.isValid = false;
          entry.errorMessage = $t("Glossary.SourceLanguageEntryNameShouldBeUnique");
        }
        validationForEmptyLanguageEntries(entry);
        validationForStringLengthCheck(entry);
      }
    } else {
      for (const entry2 of glossaryEntries) {
        validationForEmptyLanguageEntries(entry2);
        validationForStringLengthCheck(entry2);
      }
    }
  }
  return countEqualEntries <= 1;
}

function validationForEmptyLanguageEntries(glossaryEntry: GlossaryTypes.GlossaryEntry) {
  if (glossaryEntry.sourceLanguage.trim() == "" && glossaryEntry.targetLanguage.trim() == "") {
    glossaryEntry.isValid = false;
    glossaryEntry.errorMessage = $t("Glossary.SourceAndTargetLanguageEntryNamesCouldNotBeBlanked");
  } else {
    if (glossaryEntry.sourceLanguage.trim() == "") {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.SourceLanguageEntryNameCouldNotBeBlanked");
    }
    if (glossaryEntry.targetLanguage.trim() == "") {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.TargetLanguageEntryNameCouldNotBeBlanked");
    }
  }
}

function validationForStringLengthCheck(glossaryEntry: GlossaryTypes.GlossaryEntry) {
  if (glossaryEntry.sourceLanguage.trim().length > 255 && glossaryEntry.targetLanguage.trim().length > 255) {
    glossaryEntry.isValid = false;
    glossaryEntry.errorMessage = $t("Glossary.SourceAndTargetLanguageEntriesCharLimitReached");
  } else {
    if (glossaryEntry.sourceLanguage.trim().length > 255) {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.SourceLanguageEntryCharLimitReached");
    }
    if (glossaryEntry.targetLanguage.trim().length > 255) {
      glossaryEntry.isValid = false;
      glossaryEntry.errorMessage = $t("Glossary.TargetLanguageEntryCharLimitReached");
    }
  }
}

const isEveryGlossaryEntryUnique = computed(() => {
  return !validateEntries(vm.glossaryEntries);
});

const isErrorMessage = computed(() => {
  let isErrorMessage = false;
  for (const entry of vm.glossaryEntries) {
    if (entry.isValid == false) {
      isErrorMessage = true;
      break;
    }
  }
  return isErrorMessage;
});

//#endregion

//#region Map / Unmap
function mapEntriesForGlossary(entriesForGlossary: Record<string, string>) {
  vm.glossaryEntries = [];
  vm.startGlossaryEntriesToCompareChanges = [];
  if (Object.entries(entriesForGlossary).length !== 0) {
    for (const [key, value] of Object.entries(entriesForGlossary)) {
      const result: GlossaryTypes.GlossaryEntry = {
        sourceLanguage: key,
        targetLanguage: value,
        isValid: true,
        errorMessage: ""
      };
      vm.glossaryEntries.push(result);
      vm.glossaryEntries.sort((x: GlossaryTypes.GlossaryEntry, y: GlossaryTypes.GlossaryEntry) =>
        x.sourceLanguage > y.sourceLanguage ? 1 : x.sourceLanguage < y.sourceLanguage ? -1 : 0
      );
      vm.startGlossaryEntriesToCompareChanges = _.cloneDeep(vm.glossaryEntries);
    }
  }
}

function unmapEntriesForGlossary(glossaryEntriesToUnmap: GlossaryTypes.GlossaryEntry[]) {
  const newArray = extractValuesFromArray(glossaryEntriesToUnmap);
  return newArray;
}

function extractValuesFromArray(glossaryEntriesToUnmap: GlossaryTypes.GlossaryEntry[]) {
  const result: Record<string, string> = {};
  glossaryEntriesToUnmap.forEach((obj) => {
    result[`${obj.sourceLanguage}`] = obj.targetLanguage;
  });

  return result;
}
//#endregion

//#region Manipulation / Helperfunctions
const computedGlossaryTitle = computed(() => {
  return $t("Glossary.Glossary");
});

function addNewGlossaryEntry() {
  let counter = 0;
  while (vm.glossaryEntries.filter((x) => x.sourceLanguage.includes(`(${counter})`) && x.targetLanguage.includes(`(${counter})`)).length > 0) {
    counter = counter + 1;
  }
  vm.glossaryEntries.push({
    sourceLanguage: `${$t("Glossary.NewEntry")} (${counter})`,
    targetLanguage: `${$t("Glossary.NewEntry")} (${counter})`,
    isValid: true,
    errorMessage: ""
  });
  nextTick(() => {
    scrollToLastElement();
  });
}

async function scrollToLastElement() {
  if (glossaryEntriesRef.value) {
    const index = glossaryEntriesRef.value.length - 1;
    const tableRow = glossaryEntriesRef.value[index];
    tableRow?.scrollIntoView({ behavior: "smooth" });
    const inputs = tableRow?.getElementsByTagName("input");
    if (inputs && inputs.length > 0) {
      inputs[0].focus();
    }
  }
}

function deleteGlossaryEntryItem(key: number) {
  vm.glossaryEntries.splice(key, 1);
}

function isDublicatedGlossar(targetObject: GlossaryTypes.GlossaryItem) {
  if (vm.isUpdateGlossary) {
    for (let i = 0; i < vm.glossaryItems.length; i++) {
      const obj = vm.glossaryItems[i];
      if (
        obj.id !== targetObject.id &&
        obj.name === targetObject.name &&
        obj.sourceLanguage === targetObject.sourceLanguage &&
        obj.targetLanguage === targetObject.targetLanguage
      ) {
        return true;
      }
    }
    return false;
  } else {
    for (let i = 0; i < vm.glossaryItems.length; i++) {
      const obj = vm.glossaryItems[i];
      if (obj.name === targetObject.name && obj.sourceLanguage === targetObject.sourceLanguage && obj.targetLanguage === targetObject.targetLanguage) {
        return true;
      }
    }
    return false;
  }
}

function resetFlagsFromGlossaryAddUpdate() {
  vm.mainSpinner = false;
  vm.spinnerRightActive = false;
  vm.isUpdateGlossary = false;
  vm.showAddUpdateGlossary = false;
  vm.inputGlossaryName = "";
  vm.selectedSourceLanguage = null;
  vm.selectedTargetLanguage = null;
}

async function getEntriesForSelectionHandler(glossaryItemForSelectionHandler: GlossaryTypes.GlossaryItem) {
  vm.spinnerRightActive = true;
  const glossaryEntriesResponse = await glossaryApi.getGlossaryEntries(glossaryItemForSelectionHandler);
  vm.selectedOriginalGlossaryEntriesFormat = glossaryEntriesResponse;
  mapEntriesForGlossary(glossaryEntriesResponse);
  vm.spinnerRightActive = false;
}

//#endregion

//#region Api section

async function updateGlossaryEntries() {
  if (!vm.selectedGlossary) return;
  vm.spinnerRightActive = true;
  const unmappedEntries = unmapEntriesForGlossary(vm.glossaryEntries);
  const mappedUpdateObject: GlossaryTypes.GlossaryItemToUpdate = {
    updateModel: vm.selectedGlossary,
    entries: unmappedEntries
  };
  try {
    if (_.isEmpty(unmappedEntries)) {
      vm.spinnerRightActive = true;
      const recreatedGlossary: GlossaryTypes.GlossaryItemToUpdate = {
        updateModel: {
          id: "",
          name: vm.selectedGlossary.name,
          sourceLanguage: vm.selectedGlossary.sourceLanguage,
          targetLanguage: vm.selectedGlossary.targetLanguage,
          isActive: vm.selectedGlossary.isActive
        }
      };
      await glossaryApi.deleteGlossary(vm.selectedGlossary);

      vm.hasUnsavedData = false;
      const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(recreatedGlossary);
      await reloadGlossaries();

      handleGlossarySelection(dataFromUpdatedGlossary, 0);

      resetFlagsFromGlossaryAddUpdate();
    } else {
      const updatedGlossaryResponse = await glossaryApi.updateGlossary(mappedUpdateObject);
      vm.selectedGlossaryRowId = updatedGlossaryResponse.id;
      const glossaryEntriesResponse = await glossaryApi.getGlossaryEntries(updatedGlossaryResponse);
      mapEntriesForGlossary(glossaryEntriesResponse);
      await reloadGlossaries();
      vm.spinnerRightActive = false;
    }
  } catch (err) {
    console.error(err);
  }
}

function isGlossaryActiveStateUpdatable(glossaryItem: GlossaryTypes.GlossaryItem, key: number | undefined) {
  vm.selectedGlossaryItemKey = key;
  if (vm.hasUnsavedData) {
    if (confirm($t("Glossary.DiscardUnsavedEntries"))) {
      vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
      vm.selectedGlossary = glossaryItem;
      vm.hasUnsavedData = false;
      updateGlossaryActiveState(glossaryItem);
    } else {
      vm.disableHandleGlossarySelection = true;
      glossaryItem.isActive = !glossaryItem.isActive;
    }
  } else {
    updateGlossaryActiveState(glossaryItem);
  }
}

async function updateGlossaryActiveState(glossaryItem: GlossaryTypes.GlossaryItem) {
  vm.mainSpinner = true;
  vm.selectedGlossary = glossaryItem;
  let filteredGlossaryItems = _.cloneDeep(vm.glossaryItems);
  const filteredGlossaryItemsToFindKeyIn = _.cloneDeep(vm.glossaryItems);
  filteredGlossaryItems = filteredGlossaryItems.filter((x) => x.id != glossaryItem.id);
  let glossaryItemToDeactivate: GlossaryTypes.GlossaryItem | undefined = undefined;
  glossaryItemToDeactivate = filteredGlossaryItems.find(
    (x) => x.sourceLanguage == glossaryItem.sourceLanguage && x.targetLanguage == glossaryItem.targetLanguage && x.isActive
  );

  filteredGlossaryItemsToFindKeyIn.forEach(function (x, index) {
    if (x.id !== glossaryItem.id && x.sourceLanguage == glossaryItem.sourceLanguage && x.targetLanguage == glossaryItem.targetLanguage && x.isActive) {
      vm.glossaryItemKeyForGlossaryToDeactivate = index;
    }
  });

  if (!glossaryItemToDeactivate && glossaryItem.isActive) {
    addOrUpdateGlossary(undefined, true, true);
  } else if (!glossaryItem.isActive) {
    addOrUpdateGlossary(undefined, true, false);
  } else {
    if (!glossaryItemToDeactivate) return;

    if (
      confirm(
        `${$t("Glossary.ActivateGlossary")} "${glossaryItem.name}" ${$t("Glossary.DeactivateGlossary")} "${glossaryItemToDeactivate.name}" ${$t(
          "Glossary.ForLanguagePair"
        )}`
      )
    ) {
      glossaryItem.isActive = false;
      const mappedDataFromGlossaryItemToDeactivate: GlossaryTypes.GlossaryItemToUpdate = {
        updateModel: {
          id: glossaryItemToDeactivate.id,
          name: glossaryItemToDeactivate.name,
          sourceLanguage: glossaryItemToDeactivate.sourceLanguage,
          targetLanguage: glossaryItemToDeactivate.targetLanguage,
          isActive: false
        }
      };
      try {
        const deactivatedGlossaryResponse = await glossaryApi.updateGlossary(mappedDataFromGlossaryItemToDeactivate);
        const glossaryItemToChangeActiveState = vm.glossaryItems.find((element) => element.id == glossaryItemToDeactivate?.id);
        if (!glossaryItemToChangeActiveState) return;
        glossaryItemToChangeActiveState.isActive = false;
        if (vm.glossaryItemKeyForGlossaryToDeactivate !== 0 && !vm.glossaryItemKeyForGlossaryToDeactivate) return;
        vm.glossaryItems.splice(vm.glossaryItemKeyForGlossaryToDeactivate, 1, deactivatedGlossaryResponse);
        addOrUpdateGlossary(undefined, true, true);
        glossaryItem.isActive = true;
      } catch (error) {
        vm.mainSpinner = false;
        console.error(error);
      }
    } else {
      vm.mainSpinner = false;
      glossaryItem.isActive = false;
      return;
    }
  }
}

async function deleteGlossary(glossaryItem: GlossaryTypes.GlossaryItem, key: number) {
  vm.isDelete = true;
  if (vm.hasUnsavedData) {
    if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
      vm.disableHandleGlossarySelection = true;
      return;
    }
  }
  if (!confirm($t("Glossary.DeleteGlossaryConfirmation"))) {
    return;
  }
  vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
  vm.mainSpinner = true;
  vm.selectGlossary = false;
  await glossaryApi.deleteGlossary(glossaryItem);
  vm.glossaryItems.splice(key, 1);
  vm.glossaryEntries = [];
  vm.selectedGlossary = null;
  vm.mainSpinner = false;
  vm.hasUnsavedData = false;
}

async function addOrUpdateGlossary(
  createdOrUpdatedGlossary: GlossaryTypes.GlossaryItemToUpdateExtended | undefined,
  setActiveState: boolean,
  activeState: boolean
) {
  if (vm.isUpdateGlossary) {
    if (!vm.selectedGlossary || createdOrUpdatedGlossary == undefined) return;
    vm.mainSpinner = true;

    const selectedGlossaryIndex = vm.glossaryItems.indexOf(vm.selectedGlossary);
    try {
      const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossary);
      vm.glossaryItems.splice(selectedGlossaryIndex, 1, dataFromUpdatedGlossary);
      handleGlossarySelection(dataFromUpdatedGlossary, undefined);
    } catch (error) {
      console.error(error);
    }
    resetFlagsFromGlossaryAddUpdate();
  } else if (setActiveState) {
    if (!vm.selectedGlossary) return;
    const createdOrUpdatedGlossaryActiveState = {
      updateModel: {
        id: vm.selectedGlossary.id,
        name: vm.selectedGlossary.name,
        sourceLanguage: vm.selectedGlossary.sourceLanguage,
        targetLanguage: vm.selectedGlossary.targetLanguage,
        isActive: activeState
      }
    };
    try {
      const updatedGlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossaryActiveState);
      if (vm.selectedGlossaryItemKey == 0) {
        vm.selectedGlossaryItemKey = 0;
      } else {
        if (!vm.selectedGlossaryItemKey) return;
      }
      vm.glossaryItems.splice(vm.selectedGlossaryItemKey, 1, updatedGlossaryItem);
      handleGlossarySelection(updatedGlossaryItem, undefined);
    } catch (error) {
      console.error(error);
    }
    vm.mainSpinner = false;
  } else {
    vm.mainSpinner = true;

    const glossaryItemToCheckForDuplicates = {
      id: "",
      name: vm.inputGlossaryName,
      sourceLanguage: vm.selectedSourceLanguage?.languageCode as string,
      targetLanguage: vm.selectedTargetLanguage?.languageCode as string,
      isActive: false
    };
    if (createdOrUpdatedGlossary == undefined) return;
    if (!isDublicatedGlossar(glossaryItemToCheckForDuplicates)) {
      try {
        const dataFromUpdatedGlossary: GlossaryTypes.GlossaryItem = await glossaryApi.updateGlossary(createdOrUpdatedGlossary);
        await reloadGlossaries();
        handleGlossarySelection(dataFromUpdatedGlossary, undefined);
      } catch (error) {
        console.error(error);
      }
    }
    resetFlagsFromGlossaryAddUpdate();
  }
}

function handleGlossarySelection(glossaryItemForSelectionHandler: GlossaryTypes.GlossaryItem, key: number | undefined) {
  if (!vm.isDelete || !vm.disableHandleGlossarySelection) {
    if (vm.selectedGlossaryItemKey == key && vm.selectedGlossaryItemKey !== undefined) return;
    if (vm.hasUnsavedData) {
      if (!confirm($t("Glossary.DiscardUnsavedEntries"))) {
        return;
      }
    }
    vm.selectedGlossaryItemKey = key;
    vm.selectedGlossary = glossaryItemForSelectionHandler;
    vm.selectedGlossaryRowId = glossaryItemForSelectionHandler.id;
    if (vm.selectedOriginalGlossaryEntriesFormat == vm.glossaryEntries) {
      return;
    } else {
      getEntriesForSelectionHandler(glossaryItemForSelectionHandler);
    }
    vm.doneFetching = false;
    vm.hasUnsavedData = false;
    vm.selectGlossary = true;
  }
  vm.isDelete = false;
  vm.disableHandleGlossarySelection = false;
}

async function reloadGlossaries() {
  try {
    vm.mainSpinner = true;
    vm.glossaryItems = await glossaryApi.getGlossaries();
    vm.isDeeplAuthorized = true;
    vm.isDeeplAvailable = true;
    vm.isImportFileValid = true;
    vm.mainSpinner = false;
  } catch (error: any) {
    if (error && error.isAxiosError && error.response?.status == 409) {
      vm.isDeeplAuthorized = false;
    }
    if (error && error.isAxiosError && error.response?.status == 503) {
      vm.messages.message = $t("Glossary.DeeplIsNotAvailableMessage");
      vm.isDeeplAvailable = false;
    }
  }
}

function importFile() {
  const importPicker = document.getElementById("importFileForGlossaryEntries");
  if (vm.hasUnsavedData) {
    if (confirm($t("Glossary.DiscardUnsavedEntries"))) {
      if (importPicker !== null) {
        if (!vm.selectedGlossary) return;
        getEntriesForSelectionHandler(vm.selectedGlossary);
        importPicker.click();
      }
    } else {
      return;
    }
  } else {
    if (importPicker !== null) {
      importPicker.click();
    }
  }
}

async function exportGlossaryEntries() {
  try {
    if (!vm.selectedGlossary) return;
    const responseFile = await glossaryApi.exportGlossaryEntriesToFile(vm.selectedGlossary);
    const fileURL = window.URL.createObjectURL(new Blob([responseFile]));
    const exportFileLink = document.createElement("a");
    exportFileLink.href = fileURL;
    exportFileLink.setAttribute("download", `${vm.selectedGlossary?.name}.csv`);
    document.body.appendChild(exportFileLink);
    exportFileLink.click();
    document.body.removeChild(exportFileLink);
  } catch (error) {
    console.error(error);
  }
}

async function init() {
  if (vm.availableSourceLanguages.length === 0 || vm.availableTargetLanguages.length === 0) {
    loadlangauges();
  }
}

async function loadlangauges() {
  try {
    vm.glossaryLanguagePairs = await glossaryApi.getGlossaryLanguagePairs();
    vm.availableSourceLanguages = getUniqueSourceLanguages(vm.glossaryLanguagePairs);
    vm.availableTargetLanguages = getUniqueTargetLanguages(vm.glossaryLanguagePairs);
  } catch (error: any) {
    if (error?.response?.data.error == "UnAuthorized") {
      console.log($t("translation.deepLTranslation") + ": " + $t("Activity.Description.DeepLAuthorizationFailed"));
    } else {
      console.log($t("Activity.Description.DeepLTranslationFailed", { error: error?.response?.data.error ?? error.message }));
    }
    console.error(error);
  }
}

function getUniqueSourceLanguages(glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[]) {
  const uniqueLanguages: { [key: string]: GlossaryTypes.glossaryLanguage } = {};
  glossaryLanguagePairs.forEach((pair) => {
    uniqueLanguages[pair.sourceLanguage.languageCode] = pair.sourceLanguage;
  });
  return Object.values(uniqueLanguages).sort((a, b) => a.displayName.localeCompare(b.displayName));
}

function getUniqueTargetLanguages(glossaryLanguagePairs: GlossaryTypes.getGlossaryLanguagePairs[]) {
  const uniqueLanguages: { [key: string]: GlossaryTypes.glossaryLanguage } = {};
  glossaryLanguagePairs.forEach((pair) => {
    uniqueLanguages[pair.targetLanguage.languageCode] = pair.targetLanguage;
  });
  return Object.values(uniqueLanguages).sort((a, b) => a.displayName.localeCompare(b.displayName));
}

function getDisplayName(source: GlossaryTypes.glossaryLanguage[], languageCode?: string) {
  const language = source.find((x) => x.languageCode === languageCode);
  return language ? language.displayName : "";
}

function getGlossaryLangauge(source: GlossaryTypes.glossaryLanguage[], languageCode?: string) {
  const language = source.find((x) => x.languageCode === languageCode);
  return language ? language : null;
}

//#endregion

//#region Watcher

watch(
  () => vm.glossaryItems,
  () => {
    vm.glossaryItems.sort((x: GlossaryTypes.GlossaryItem, y: GlossaryTypes.GlossaryItem) => (x.name > y.name ? 1 : x.name < y.name ? -1 : 0));
  },
  { deep: true, immediate: true }
);

watch(
  () => vm.file,
  async () => {
    if (!_.isEmpty(vm.file)) {
      try {
        vm.mainSpinner = true;

        if (!vm.selectedGlossary) return;
        const UpdatedGlossaryItemResponse = await glossaryApi.importGlossaryEntriesFromFile(vm.selectedGlossary, vm.file);
        await reloadGlossaries();
        handleGlossarySelection(UpdatedGlossaryItemResponse, undefined);
        vm.file = [];
      } catch (error: any) {
        let errorMessage = "";
        if (error && error.isAxiosError) {
          if (error.response?.status == 409) {
            console.error(error);
            errorMessage = $t("Glossary.ImportWrongFileType");
          }
          if (error.response?.status === 400 && error.response.data?.File && error.response.data.File.length > 0) {
            errorMessage = $t("api.errors." + error.response.data.File[0]);
          } else {
            errorMessage = $t("Glossary.ImportWrongFileType");
          }
          vm.messages.message = errorMessage;
          vm.isImportFileValid = false;
          vm.file = [];
        }
      } finally {
        vm.mainSpinner = false;
      }
    }
  },
  { deep: true }
);

watch(
  () => vm.glossaryEntries,
  () => {
    if (vm.doneFetching) {
      if (JSON.stringify(vm.glossaryEntries) == JSON.stringify(vm.startGlossaryEntriesToCompareChanges)) {
        vm.hasUnsavedData = false;
      } else {
        if (_.isEmpty(vm.selectedGlossary)) {
          vm.hasUnsavedData = false;
        } else {
          vm.hasUnsavedData = true;
        }
      }
    }
    vm.doneFetching = true;
  },
  { deep: true }
);

watch(
  () => vm.showAddUpdateGlossary,
  async () => {
    if (!vm.isUpdateGlossary) {
      vm.isAddGlossary = vm.showAddUpdateGlossary;
    }

    if (vm.showAddUpdateGlossary) {
      if (vm.hasUnsavedData) {
        if (confirm($t("Glossary.AddUpdateWithUnsavedEntries"))) {
          vm.glossaryEntries = vm.startGlossaryEntriesToCompareChanges;
          vm.hasUnsavedData = false;
        } else {
          vm.showAddUpdateGlossary = false;
          return;
        }
      }
      vm.inputGlossaryName = "";
      vm.selectedSourceLanguage = null;
      vm.selectedTargetLanguage = null;
      if (vm.isUpdateGlossary && vm.selectedGlossary) {
        vm.inputGlossaryName = vm.selectedGlossary.name;
        vm.selectedSourceLanguage = getGlossaryLangauge(vm.availableSourceLanguages, vm.selectedGlossary?.sourceLanguage);
        vm.selectedTargetLanguage = getGlossaryLangauge(vm.availableTargetLanguages, vm.selectedGlossary?.targetLanguage);
      }
    } else {
      vm.inputGlossaryName = "";
      vm.selectedSourceLanguage = null;
      vm.selectedTargetLanguage = null;
      vm.isUpdateGlossary = false;
    }
    vm.doneFetching = true;
  },
  { deep: true }
);

watch(
  () => modal.value?.isShow,
  async () => {
    if (modal.value?.isShow) {
      if (user.value.isDeeplAuthorized) {
        await reloadGlossaries();
        vm.initialized = true;
        if (vm.glossaryItems && vm.glossaryItems.length > 0) {
          handleGlossarySelection(vm.glossaryItems[0], 0);
        }
      }
    } else {
      vm.glossaryItems = [];
      vm.glossaryEntries = [];
      vm.selectedGlossary = null;
      vm.selectGlossary = false;
      vm.hasUnsavedData = false;
      vm.initialized = false;
    }
  },
  {}
);
//#endregion

//#region Lifecycle hooks

function modalOpenEventHandler() {
  if (props.modalName == "glossary-modal-attribute-tab") {
    vm.openModalFromContextMenu = true;
  }
}

onMounted(() => {
  emitter.on("open-glossary-modal-from-context-menu", modalOpenEventHandler);
});

onBeforeUnmount(() => {
  emitter.off("open-glossary-modal-from-context-menu", modalOpenEventHandler);
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_form_file = _resolveComponent("b-form-file")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    "header-close-content": "",
    modelValue: vm.openModalFromContextMenu,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((vm.openModalFromContextMenu) = $event)),
    bodyClass: "glossaryModal",
    title: computedGlossaryTitle.value,
    size: "xl",
    id: _ctx.modalName,
    ref_key: "modal",
    ref: modal,
    onShown: init,
    onHide: handleCloseModal
  }, {
    "modal-footer": _withCtx(({ cancel }) => [
      _createVNode(_component_b_button, {
        variant: "primary",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (updateGlossaryEntries())),
        disabled: !vm.hasUnsavedData || isEveryGlossaryEntryUnique.value || isErrorMessage.value || vm.mainSpinner || vm.spinnerRightActive,
        "data-cy": "glossary-entries-save-btn"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("Glossary.Save")), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_b_button, { onClick: cancel }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref($t)("close")), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_b_overlay, {
          "z-index": "20",
          opacity: "1",
          variant: "white",
          "no-wrap": "",
          "data-cy": "spinnerLeft",
          show: vm.mainSpinner
        }, {
          overlay: _withCtx(() => [
            _createVNode(spinner, { size: "48" })
          ]),
          _: 1
        }, 8, ["show"]),
        _createVNode(GridSplitter, null, {
          left: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "btn btn-with-icon mono",
                  "data-cy": "add-glossary-btn",
                  disabled: vm.spinnerRightActive,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (((vm.showAddUpdateGlossary = !vm.showAddUpdateGlossary), (vm.isAddGlossary = !vm.isAddGlossary))))
                }, [
                  _hoisted_5,
                  _createTextVNode(" " + _toDisplayString(_unref($t)("Glossary.NewGlossary")), 1)
                ], 8, _hoisted_4)
              ]),
              (!_unref(_).isEmpty(vm.glossaryItems))
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", null, _toDisplayString(_unref($t)("Glossary.Name")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", null, _toDisplayString(_unref($t)("Glossary.SourceLanguage")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", null, _toDisplayString(_unref($t)("Glossary.TargetLanguage")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", null, _toDisplayString(_unref($t)("Glossary.Active")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.glossaryItems, (glossaryItem, key) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["glossary-table-row-data fallback-hint-container", { active: vm.selectedGlossaryRowId === glossaryItem.id && vm.selectGlossary }]),
                            "data-cy": "glossary-table-row-data",
                            key: key
                          }, [
                            _createElementVNode("div", {
                              class: "options-column",
                              onClick: ($event: any) => (handleGlossarySelection(glossaryItem, key))
                            }, [
                              _createVNode(_component_b_dropdown, {
                                "no-caret": "",
                                variant: "primary",
                                class: "table-option",
                                "toggle-class": "popup-menu-button",
                                "menu-class": "popup-menu",
                                "data-cy": 'menu-' + glossaryItem.name
                              }, {
                                "button-content": _withCtx(() => [
                                  _hoisted_16
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_b_dropdown_item, {
                                    href: "#",
                                    "link-class": "menu-option last-option",
                                    "data-cy": 'glossary-edit-btn-' + glossaryItem.name,
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (((vm.showAddUpdateGlossary = !vm.showAddUpdateGlossary), (vm.isUpdateGlossary = !vm.isUpdateGlossary))))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_17,
                                      _createElementVNode("span", _hoisted_18, _toDisplayString(_unref($t)("Glossary.Edit")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["data-cy"]),
                                  _createVNode(_component_b_dropdown_item, {
                                    href: "#",
                                    "link-class": "menu-option first-option",
                                    "data-cy": 'glossary-delete-btn-' + glossaryItem.name,
                                    onClick: ($event: any) => (deleteGlossary(glossaryItem, key))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_19,
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref($t)("Glossary.Delete")), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["data-cy", "onClick"])
                                ]),
                                _: 2
                              }, 1032, ["data-cy"])
                            ], 8, _hoisted_15),
                            _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: "glossary-table-col custom-width-col pl-1 mr-1",
                              id: "glossary-item-full-name",
                              "data-cy": glossaryItem.name,
                              onClick: ($event: any) => (handleGlossarySelection(glossaryItem, key))
                            }, [
                              _createTextVNode(_toDisplayString(glossaryItem.name), 1)
                            ], 8, _hoisted_21)), [
                              [_directive_tooltip, glossaryItem.name]
                            ]),
                            _createElementVNode("div", {
                              class: "glossary-table-col value-col",
                              onClick: ($event: any) => (handleGlossarySelection(glossaryItem, key))
                            }, _toDisplayString(getDisplayName(vm.availableSourceLanguages, glossaryItem.sourceLanguage)), 9, _hoisted_22),
                            _createElementVNode("div", {
                              class: "glossary-table-col value-col",
                              onClick: ($event: any) => (handleGlossarySelection(glossaryItem, key))
                            }, _toDisplayString(getDisplayName(vm.availableTargetLanguages, glossaryItem.targetLanguage)), 9, _hoisted_23),
                            _createElementVNode("div", {
                              class: "glossary-table-col active-col pl-0 mr-0",
                              onClick: ($event: any) => (handleGlossarySelection(glossaryItem, key)),
                              "data-cy": 'checkbox-' + glossaryItem.name
                            }, [
                              _createVNode(_component_b_checkbox, {
                                class: "ml-2",
                                modelValue: glossaryItem.isActive,
                                "onUpdate:modelValue": ($event: any) => ((glossaryItem.isActive) = $event),
                                onChange: ($event: any) => (isGlossaryActiveStateUpdatable(glossaryItem, key))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ], 8, _hoisted_24)
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref($t)("Glossary.AddNewGlossary")), 1))
            ])
          ]),
          right: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_b_overlay, {
                "z-index": "20",
                opacity: "1",
                variant: "white",
                "no-wrap": "",
                "data-cy": "spinnerRight",
                show: vm.spinnerRightActive && !vm.mainSpinner
              }, {
                overlay: _withCtx(() => [
                  _createVNode(spinner, { size: "48" })
                ]),
                _: 1
              }, 8, ["show"]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_b_row, { class: "mx-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_col, {
                        class: "button-area pr-0",
                        "data-cy": "add-glossary-entry-btn"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-with-icon mono",
                            disabled: !vm.selectGlossary || _unref(_).isEmpty(vm.glossaryItems) || _unref(_).isEmpty(vm.selectedGlossary) || vm.mainSpinner,
                            onClick: addNewGlossaryEntry
                          }, [
                            _hoisted_30,
                            _createTextVNode(" " + _toDisplayString(_unref($t)("Glossary.NewWordPair")), 1)
                          ], 8, _hoisted_29)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, { class: "button-area px-0" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_b_form_file, {
                            id: "importFileForGlossaryEntries",
                            accept: ".csv",
                            modelValue: vm.file,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((vm.file) = $event))
                          }, null, 8, ["modelValue"]), [
                            [_vShow, false]
                          ]),
                          _createElementVNode("button", {
                            class: "btn btn-with-icon mono",
                            disabled: !vm.selectGlossary || _unref(_).isEmpty(vm.glossaryItems) || _unref(_).isEmpty(vm.selectedGlossary) || vm.mainSpinner,
                            onClick: importFile
                          }, [
                            _hoisted_32,
                            _createTextVNode(" " + _toDisplayString(_unref($t)("Glossary.Import")), 1)
                          ], 8, _hoisted_31)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_b_col, { class: "button-area px-0" }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "btn btn-with-icon mono",
                            disabled: !vm.selectedGlossary || vm.hasUnsavedData || vm.mainSpinner,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (exportGlossaryEntries()))
                          }, [
                            _hoisted_34,
                            _createTextVNode(" " + _toDisplayString(_unref($t)("Glossary.Export")), 1)
                          ], 8, _hoisted_33)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                (!_unref(_).isEmpty(vm.glossaryEntries))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode(_component_b_row, { class: "glossary-custom-row" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_b_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", null, _toDisplayString(getDisplayName(vm.availableSourceLanguages, vm.selectedGlossary?.sourceLanguage)), 1)
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_b_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("div", null, _toDisplayString(getDisplayName(vm.availableTargetLanguages, vm.selectedGlossary?.targetLanguage)), 1)
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.glossaryEntries, (glossaryEntryItem, key) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "glossary-table-row-data",
                              ref_for: true,
                              ref_key: "glossaryEntriesRef",
                              ref: glossaryEntriesRef,
                              "data-cy": 'delete-glossary-entry-row' + key,
                              key: key
                            }, [
                              _createElementVNode("div", {
                                class: "options-column-entries",
                                "data-cy": 'options-glossary-entry-btn' + key
                              }, [
                                _createVNode(_component_b_dropdown, {
                                  "no-caret": "",
                                  variant: "primary",
                                  class: "table-option",
                                  "toggle-class": "popup-menu-button",
                                  "menu-class": "popup-menu"
                                }, {
                                  "button-content": _withCtx(() => [
                                    _hoisted_44
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_b_dropdown_item, {
                                      href: "#",
                                      "link-class": "menu-option first-option",
                                      "data-cy": 'delete-glossary-entry-btn' + key,
                                      onClick: ($event: any) => (deleteGlossaryEntryItem(key))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_45,
                                        _createElementVNode("span", _hoisted_46, _toDisplayString(_unref($t)("Glossary.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["data-cy", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ], 8, _hoisted_43),
                              _createVNode(_component_b_row, { class: "glossary-custom-row" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_b_col, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_b_input, {
                                        class: _normalizeClass(["glossary-table-col entry-col mt-2", { 'border-danger': !glossaryEntryItem.isValid }]),
                                        modelValue: glossaryEntryItem.sourceLanguage,
                                        "onUpdate:modelValue": ($event: any) => ((glossaryEntryItem.sourceLanguage) = $event),
                                        "data-cy": glossaryEntryItem.isValid ? 'source-language-entry' + key : 'sl-border-danger' + key
                                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "data-cy"]), [
                                        [_directive_tooltip, glossaryEntryItem.errorMessage]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_b_col, null, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_b_input, {
                                        class: _normalizeClass(["glossary-table-col entry-col mt-2", { 'border-danger': !glossaryEntryItem.isValid }]),
                                        modelValue: glossaryEntryItem.targetLanguage,
                                        "onUpdate:modelValue": ($event: any) => ((glossaryEntryItem.targetLanguage) = $event),
                                        "data-cy": glossaryEntryItem.isValid ? 'target-language-entry' + key : 'tl-border-danger' + key
                                      }, null, 8, ["class", "modelValue", "onUpdate:modelValue", "data-cy"]), [
                                        [_directive_tooltip, glossaryEntryItem.errorMessage]
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ], 8, _hoisted_42))
                          }), 128))
                        ])
                      ])
                    ]))
                  : (_unref(_).isEmpty(vm.glossaryItems))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_unref($t)("Glossary.AddNewGlossaryAndEntry")), 1))
                    : (_unref(_).isEmpty(vm.selectedGlossary))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_unref($t)("Glossary.SelectGlossaryForGetEntries")), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref($t)("Glossary.AddGlossaryEntry")), 1))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode(AddUpdateGlossaryModal, {
        "show-modal": vm.showAddUpdateGlossary,
        "onUpdate:showModal": _cache[5] || (_cache[5] = ($event: any) => ((vm.showAddUpdateGlossary) = $event)),
        glossaryItems: vm.glossaryItems,
        selectedGlossary: vm.selectedGlossary,
        selectedSourceLanguage: vm.selectedSourceLanguage,
        selectedTargetLanguage: vm.selectedTargetLanguage,
        inputGlossaryName: vm.inputGlossaryName,
        availableSourceLanguages: vm.availableSourceLanguages,
        availableTargetLanguages: vm.availableTargetLanguages,
        glossaryLanguagePairs: vm.glossaryLanguagePairs,
        isUpdateGlossary: vm.isUpdateGlossary,
        isAddGlossary: vm.isAddGlossary,
        onAddOrUpdateFromModal: addOrUpdateGlossary
      }, null, 8, ["show-modal", "glossaryItems", "selectedGlossary", "selectedSourceLanguage", "selectedTargetLanguage", "inputGlossaryName", "availableSourceLanguages", "availableTargetLanguages", "glossaryLanguagePairs", "isUpdateGlossary", "isAddGlossary"]),
      (vm.initialized && (!vm.isDeeplAuthorized || !vm.isDeeplAvailable || !vm.isImportFileValid))
        ? (_openBlock(), _createBlock(WarningModal, {
            key: 0,
            id: "warning-modal",
            "show-modal": vm.openModalFromContextMenu,
            "onUpdate:showModal": _cache[6] || (_cache[6] = ($event: any) => ((vm.openModalFromContextMenu) = $event)),
            title: vm.messages.title,
            message: vm.messages.message
          }, null, 8, ["show-modal", "title", "message"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "title", "id"]))
}
}

})